import type { Area, Point } from "../Cropper";

export interface ImageEditorState {
  crop: Point;
  cropArea: Area | null;
  embedUrl: string;
  fileList?: FileList;
  imageError: string;
  stringFile?: string;
  zoom: number;
}

export type ImageEditorAction =
  | { type: "SELECT_FILE"; fileList: FileList; preview: string }
  | { type: "SET_PREVIEW"; preview: string }
  | { type: "SET_EMBED_URL"; url: string }
  | { type: "SET_CROP"; crop: Point }
  | { type: "SET_ZOOM"; zoom: number }
  | { type: "SET_CROP_AREA"; area: Area }
  | { type: "SET_ERROR"; message: string }
  | { type: "CLEAR_ERROR" }
  | { type: "RESET" };

export const initialState: ImageEditorState = {
  fileList: undefined,
  stringFile: undefined,
  crop: { x: 0, y: 0 },
  cropArea: null,
  zoom: 1,
  embedUrl: "",
  imageError: "",
};

export const reducer = (
  state: ImageEditorState,
  action: ImageEditorAction,
): ImageEditorState => {
  switch (action.type) {
    case "SELECT_FILE":
      return {
        ...state,
        fileList: action.fileList,
        stringFile: action.preview,
        imageError: "",
      };
    case "SET_PREVIEW":
      return { ...state, stringFile: action.preview };
    case "SET_EMBED_URL":
      return { ...state, embedUrl: action.url, imageError: "" };
    case "SET_CROP":
      return { ...state, crop: action.crop };
    case "SET_ZOOM":
      return { ...state, zoom: action.zoom };
    case "SET_CROP_AREA":
      return { ...state, cropArea: action.area };
    case "SET_ERROR":
      return { ...state, imageError: action.message };
    case "CLEAR_ERROR":
      return { ...state, imageError: "" };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};
